import { render, staticRenderFns } from "./NovaParcela.vue?vue&type=template&id=b41fb1e6"
import script from "./NovaParcela.vue?vue&type=script&lang=js"
export * from "./NovaParcela.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports